import React, { useEffect } from 'react';
import { companyInfo } from '../data/mock';

const AGBPage = () => {
  useEffect(() => {
    document.title = 'AGB | Allgemeine Geschäftsbedingungen | Helper-Schweiz';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Allgemeine Geschäftsbedingungen (AGB) von Helper-Schweiz für Entrümpelung und Haushaltsauflösung in der Deutschschweiz.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#f0f5fa] to-[#e8f0f8] py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">AGB – Helper Schweiz</h1>
          <p className="mt-4 text-gray-600 text-lg">{companyInfo.name}</p>
        </div>
      </section>

      {/* AGB Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            {/* Company Info */}
            <div className="bg-[#f8fafc] rounded-2xl p-6 mb-8">
              <p className="font-semibold text-[#1e3a5f] text-lg">{companyInfo.name}</p>
              <p className="text-gray-600">Inhaber: {companyInfo.owner}</p>
              <p className="text-gray-600">{companyInfo.address}</p>
              <p className="text-gray-600">Telefon: {companyInfo.phone}</p>
              <p className="text-gray-600">E-Mail: {companyInfo.email}</p>
            </div>

            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">1. Geltungsbereich</h2>
                <p className="text-gray-600">Diese AGB gelten für alle Dienstleistungen von Helper Schweiz.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">2. Dienstleistungen</h2>
                <p className="text-gray-600">Entrümpelungen, Räumungen, Transporte, Sortierarbeiten, Entsorgung.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">3. Preise & Abrechnung</h2>
                <p className="text-gray-600">Stundenansatz oder Pauschale. Entsorgung separat. Keine MWST-Pflicht.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">4. Zahlungsbedingungen</h2>
                <p className="text-gray-600">Zahlung sofort oder in 10 Tagen. Nach 30 Tagen erfolgt Betreibung inkl. Kosten.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">5. Eigentumsregelung</h2>
                <p className="text-gray-600">Aussortierte Gegenstände gehen – sofern vereinbart – in Eigentum von Helper Schweiz über.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">6. Wertgegenstände</h2>
                <p className="text-gray-600">Gefundene Wertgegenstände werden gemeldet und übergeben.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">7. Haftung</h2>
                <p className="text-gray-600">Keine Haftung für Vorschäden, instabile Möbel, falsch verpackte Gegenstände, indirekte Schäden, falsche Angaben des Auftraggebers. Haftung nur bei grober Fahrlässigkeit, begrenzt auf Auftragswert.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">8. Dokumentation</h2>
                <p className="text-gray-600">Fotos zur Dokumentation erlaubt, keine Veröffentlichung.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">9. Mehraufwand</h2>
                <p className="text-gray-600">Bei abweichendem Aufwand Preisänderung möglich.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">10. Gefahrstoffe</h2>
                <p className="text-gray-600">Bei Schimmel, Fäkalien, Tierkot, Chemikalien, Asbest kann Auftrag abgebrochen oder Zuschlag erhoben werden.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">11. Park- & Zugangskosten</h2>
                <p className="text-gray-600">Kosten & Bussen infolge Kundenanweisungen werden verrechnet. Zugang muss frei sein.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">12. Infrastruktur</h2>
                <p className="text-gray-600">Kunde sorgt für Licht, Strom, freie Wege. Fehlendes führt zu Mehrkosten.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">13. Arbeitsunterbrechungen</h2>
                <p className="text-gray-600">Unterbrechungen durch Dritte werden verrechnet.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">14. Wartezeiten</h2>
                <p className="text-gray-600">Vom Kunden verursachte Wartezeiten werden berechnet.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">15. Schlüssel</h2>
                <p className="text-gray-600">Haftung nur bei grober Fahrlässigkeit.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">16. Höhere Gewalt</h2>
                <p className="text-gray-600">Keine Haftung bei Krankheit, Unfall, Wetter, Behördenauflagen.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">17. Rücktrittsrecht</h2>
                <p className="text-gray-600">Abbruch bei Gefahr, unklaren Eigentumsverhältnissen oder unzumutbaren Bedingungen.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">18. Wahrheitspflicht</h2>
                <p className="text-gray-600">Kunde muss vollständig & korrekt informieren.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">19. Transport</h2>
                <p className="text-gray-600">Keine Garantie für Stabilität von Möbeln.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">20. Entsorgung</h2>
                <p className="text-gray-600">Entsorgung nach Ermessen, keine Haftung für Verzögerungen durch Entsorgungsstellen.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">21. Keine Aufbewahrungspflicht</h2>
                <p className="text-gray-600">Keine Aufbewahrung von Gegenständen.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">22. Datenschutz</h2>
                <p className="text-gray-600">Dokumente vertraulich, keine Haftung für Vollständigkeit.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">23. Drittpersonen</h2>
                <p className="text-gray-600">Keine Haftung bei falschen Angaben von Nachbarn, Verwandten etc.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">24. Schädlinge</h2>
                <p className="text-gray-600">Keine Haftung für Schädlingsbefall, Auftrag kann abgebrochen werden.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">25. Materialpauschale</h2>
                <p className="text-gray-600">Verbrauchsmaterial & Werkzeugabnutzung können verrechnet werden.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">26. Schriftform</h2>
                <p className="text-gray-600">Änderungen nur schriftlich gültig.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">27. Salvatorische Klausel</h2>
                <p className="text-gray-600">Ungültige Bestimmungen beeinträchtigen übrige nicht.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">28. Stornierungen</h2>
                <p className="text-gray-600">Bis 24h kostenlos, 24h = 50 %, am selben Tag = 100 %.</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#1e3a5f] mb-2">29. Gerichtsstand</h2>
                <p className="text-gray-600">Gerichtsstand ist Frauenfeld (TG).</p>
              </div>

              <div className="pt-8 border-t mt-8">
                <p className="text-gray-500 text-sm">
                  Stand: 2026
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  {companyInfo.name}<br />
                  {companyInfo.owner}<br />
                  {companyInfo.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AGBPage;
